import Token from '../../data/models/Token';
export var register = function register(data) {
  var _data$register;
  return {
    token: Token(data == null ? void 0 : data.register),
    user: data == null ? void 0 : (_data$register = data.register) == null ? void 0 : _data$register.user
  };
};